import { css } from 'linaria';
import { styled } from 'linaria/react';

export const stretchBannerLinkStyles = css`
  display: flex;
  justify-content: center;
  width: 100%;

  @media (max-width: 618px) {
    justify-content: flex-end;
    padding-left: var(--space-200);
    padding-right: 100px;
  }
`;

export const StretchBannerWrapper = styled.div<{ backgroundColor: string }>`
  position: relative;
  display: flex;
  align-items: center;
  width: 100vw;
  background: ${({ backgroundColor }) => backgroundColor || 'transparent'};
`;
